export const fromLongToShort = {
  ar_AE: 'ar',
  de_DE: 'de',
  en_US: 'en',
  es_ES: 'es',
  fr_FR: 'fr',
  hi_IN: 'hi',
  hu_HU: 'hu',
  id_ID: 'id',
  it_IT: 'it',
  ja_JP: 'ja',
  ko_KO: 'ko',
  pl_PL: 'pl',
  pt_PT: 'pt',
  ro_RO: 'ro',
  ru_RU: 'ru',
  tr_TR: 'tr',
  vi_VN: 'vi',
  zh_ZH: 'zh',
  uz_UZ: 'uz',
  ky_KY: 'ky',
  fil_FIL: 'fil'
};

export const fromShortToLong = {
  ar: 'ar_AE',
  de: 'de_DE',
  en: 'en_US',
  es: 'es_ES',
  fr: 'fr_FR',
  hi: 'hi_IN',
  hu: 'hu_HU',
  id: 'id_ID',
  it: 'it_IT',
  ja: 'ja_JP',
  ko: 'ko_KO',
  pl: 'pl_PL',
  pt: 'pt_PT',
  ro: 'ro_RO',
  ru: 'ru_RU',
  tr: 'tr_TR',
  vi: 'vi_VN',
  zh: 'zh_ZH',
  ky: 'ky_KY',
  uz: 'uz_UZ',
  fil: 'fil_FIL'
};


export const availableInDE = {
  en: 'en_US',
  es: 'es_ES',
  fr: 'fr_FR',
  hu: 'hu_HU',
  it: 'it_IT',
  pl: 'pl_PL',
  pt: 'pt_PT',
  ru: 'ru_RU',
  tr: 'tr_TR'
};


export const sourceLanguagesForEN = {
  ar: 'ar_AE',
  de: 'de_DE',
  en: 'en_US',
  es: 'es_ES',
  fr: 'fr_FR',
  hi: 'hi_IN',
  hu: 'hu_HU',
  id: 'id_ID',
  it: 'it_IT',
  ja: 'ja_JP',
  ko: 'ko_KO',
  pl: 'pl_PL',
  pt: 'pt_PT',
  ro: 'ro_RO',
  ru: 'ru_RU',
  tr: 'tr_TR',
  vi: 'vi_VN'
};

export const sourceLanguagesForDE = {
  en: 'en_US',
  es: 'es_ES',
  fr: 'fr_FR',
  hu: 'hu_HU',
  it: 'it_IT',
  pl: 'pl_PL',
  pt: 'pt_PT',
  ru: 'ru_RU',
  tr: 'tr_TR'
};

export const sourceLanguagesForES = {
  en: 'en_US',
  hu: 'hu_HU'
};

export const sourceLanguagesForFR = {
  en: 'en_US',
  hu: 'hu_HU'
};

export const sourceLanguagesForHU = {
  ar: 'ar_AE',
  de: 'de_DE',
  en: 'en_US',
  es: 'es_ES',
  fr: 'fr_FR',
  hi: 'hi_IN',
  id: 'id_ID',
  it: 'it_IT',
  ja: 'ja_JP',
  ko: 'ko_KO',
  pl: 'pl_PL',
  pt: 'pt_PT',
  ro: 'ro_RO',
  ru: 'ru_RU',
  tr: 'tr_TR',
  vi: 'vi_VN',
  fil: 'fil_FIL',
  ky: 'ky_KY',
  uz: 'uz_UZ',
  zh: 'zh_ZH'
};

export const sourceLanguagesForESP = {
  en: 'en_US',
  hu: 'hu_HU',
  de: 'de_DE',
  es: 'es_ES',
  fr: 'fr_FR',
  it: 'it_IT',
  pt: 'pt_PT',
  ru: 'ru_RU',
  zh: 'zh_ZH'
};

const detectSubDomain = () => {
  try {
    const full = window.location.host;
    // window.location.host is subdomain.domain.com
    const parts = full.split('.');
    const sub = parts[0];
    return sub;
  } catch (e) {
    return undefined;
  }
};

// Detect subdomain and after browser language
export const detectBrowserLanguage = () => {
  const subDomain = detectSubDomain();

  if (subDomain && subDomain.length === 2) {
    return fromShortToLong[subDomain];
  }
  let locale = navigator.language;
  if (locale) {
    locale = locale.split('-')[0];
    locale = fromShortToLong[locale];
  }
  if (!locale) {
    locale = 'en_US';
  }
  return locale;
};



// WEBPACK FOOTER //
// ./src/components/shared/languageCodes.js